import { ErrorHandlerSnackbarRequestObject } from "@/store/app/state";

export const loginPhoneSnackbarErrorObject: ErrorHandlerSnackbarRequestObject =
  {
    default: {
      title: "snackbar.errors.invalidSmsCode.title",
      text: "snackbar.errors.invalidSmsCode.text",
    },
    "401": {
      title: "snackbar.errors.invalidSmsCode.title",
      text: "snackbar.errors.invalidSmsCode.text",
    },
    "406": {
      title: "snackbar.errors.accountWasClosedLogin.title",
      text: "snackbar.errors.accountWasClosedLogin.text",
      timeoutSeconds: 10,
    },
  };
